var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-popover',{attrs:{"placement":_vm.placement,"custom-class":("al-contextual-menu-body " + _vm.position),"target":_vm.target,"test-id":"al-popover"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }